/**
 * Maps raw API movements into the same shape as storedMovements,
 * accumulating quantities per ware across all matching movements.
 */
export const parseApiMovements = (movements) => {
  const waresMap = {};

  for (const movement of movements) {
    const wareId = movement.wares?._id;
    if (!wareId) continue;

    if (!waresMap[wareId]) {
      waresMap[wareId] = {
        wares: wareId,
        consumption: { quantity: 0, notes: "" },
        sale_movement_unit: {
          payment_method_money: { quantity: 0, notes: "" },
          payment_method_card: { quantity: 0, notes: "" },
        },
        sale_sale_unit: {
          payment_method_money: { quantity: 0, notes: "" },
          payment_method_card: { quantity: 0, notes: "" },
        },
      };
    }

    const entry = waresMap[wareId];
    const isCash = movement.payment_method === movement.equipment?.payment_method;
    const paymentKey = isCash ? "payment_method_money" : "payment_method_card";

    if (movement.type?.name === "Venda") {
      if (!movement.sale_quantity) {
        // Venda por unidade de movimento
        entry.sale_movement_unit[paymentKey].quantity += Math.abs(movement.quantity ?? 0);
      } else if (movement.sale_quantity && movement.quantity) {
        // Venda por unidade de venda
        entry.sale_sale_unit[paymentKey].quantity += Math.abs(movement.sale_quantity ?? 0);
      }
    }

    if (movement.type?.name === "Consumo" && movement.sale_quantity && movement.quantity) {
      entry.consumption.quantity += Math.abs(movement.sale_quantity ?? 0);
    }
  }

  return Object.values(waresMap);
};
